import React from 'react';
import { Search } from 'lucide-react';
interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}
export function SearchBar({
  value,
  onChange,
  placeholder = 'Search...'
}: SearchBarProps) {
  return <div className="relative" data-id="element-261">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" strokeWidth={2} data-id="element-262" />
      <input type="text" value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} className="w-full pl-12 pr-4 py-3 bg-white border border-gray-300 focus:border-charcoal focus:outline-none transition-colors text-sm" data-id="element-263" />
    </div>;
}